import { apiClient } from "../../../api/client";
import * as ActionType from "./product.type";
import { setToast } from "../../../util/toast";

const normalizeError = (error) => ({
  message: error?.message || "Request failed",
  code: error?.code || "UNKNOWN",
  details: error?.details || {},
});

// GET ALL PRODUCT
export const getProduct = (start, limit) => async (dispatch) => {
  dispatch({ type: ActionType.GET_REAL_PRODUCT_REQUEST });
  const res = await apiClient.get(`product/getRealProducts?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({ type: ActionType.GET_REAL_PRODUCT_SUCCESS });
    dispatch({
      type: ActionType.GET_REAL_PRODUCT,
      payload: res.data,
      totalProduct: res.data?.totalProducts,
    });
  } else {
    dispatch({
      type: ActionType.GET_REAL_PRODUCT_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};
export const getFakeProduct = (start, limit) => async (dispatch) => {
  const res = await apiClient.get(`product/getFakeProducts?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_FAKE_PRODUCT,
      payload: res.data,
      totalProduct: res.data?.totalProducts,
    });
  } else {
    console.error(res.message);
  }
};

// CREATE_CATEGORY
export const createProduct = (formData) => async (dispatch) => {
  const res = await apiClient.post("product/createProductByAdmin", formData);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.CREATE_PRODUCT,
      payload: res.data.product,
    });
    setToast("success", "Product Create successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// UPDATE_CATEGORY
export const updateProduct =
  (formData, id, sellerId, productCode) => async (dispatch) => {
    const res = await apiClient.patch(
      `product/update?productId=${id}&sellerId=${sellerId}&productCode=${productCode}`,
      formData
    );
    if (res.ok && res.data?.status) {
      dispatch({
        type: ActionType.UPDATE_PRODUCT,
        payload: { data: res.data.product, id },
      });
      setToast("success", "Product update successfully");
    } else {
      setToast("error", res.data?.message || res.message);
    }
  };

// DELETE_CATEGORY
export const deleteProduct = (id) => async (dispatch) => {
  const res = await apiClient.delete(`product/delete?productId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DELETE_PRODUCT,
      payload: id,
    });
    setToast("success", "Product Delete successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_NEW_COLLECTION
export const NewCollection = (product, collection) => async (dispatch) => {
  const res = await apiClient.patch(`product/isNewCollection?productId=${product}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.PRODUCT_NEW_COLLECTION,
      payload: { data: res.data.product, id: collection._id },
    });

    setToast(
      "success",
      `${collection?.seller?.firstName} Is ${
        res.data.product.isNewCollection == true
          ? "Add New Collection"
          : "Remove New Collection"
      } Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_OUT OF STOCK
export const outOfStock = (product, stock) => async (dispatch) => {
  const res = await apiClient.patch(`product/isOutOfStock?productId=${product}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.PRODUCT_OUT_OF_STOCK,
      payload: { data: res.data.product, id: stock._id },
    });

    setToast(
      "success",
      `${stock?.seller?.firstName} Is ${
        stock.isOutOfStock == true ? "Instock Product" : "Out Of Stock Product"
      } Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_DETAIL
export const getProductDetail = (id) => async (dispatch) => {
  dispatch({ type: ActionType.PRODUCT_DETAIL_REQUEST });
  const res = await apiClient.get(`product/productDetailsForAdmin?productId=${id}`);
  if (res.ok) {
    dispatch({ type: ActionType.PRODUCT_DETAIL_SUCCESS });
    dispatch({
      type: ActionType.PRODUCT_DETAIL,
      payload: res.data?.product,
    });
  } else {
    dispatch({
      type: ActionType.PRODUCT_DETAIL_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};

// PRODUCT_REVIEW
export const getProductReview = (id, start, limit) => async (dispatch) => {
  const res = await apiClient.get(
    `review/getreview?productId=${id}&start=${start}&limit=${limit}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.PRODUCT_REVIEW,
      payload: res.data?.reviews,
    });
  } else {
    console.error(res.message);
  }
};

// get Product request
export const getProductRequest = (status) => async (dispatch) => {
  const res = await apiClient.get(
    `product/createProductRequestStatusWise?status=${status}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.PRODUCT_REQUEST,
      payload: res.data?.products,
    });
  } else {
    console.log(res.message);
  }
};

export const productAction = (productId, type) => async (dispatch) => {
  const res = await apiClient.patch(
    `product/acceptCreateRequest?productId=${productId}&type=${type}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.PRODUCT_REQUEST_ACTION,
      payload: productId,
    });
    type === "Approved"
      ? setToast("success", "Product Request Accepted")
      : setToast("success", "Product Request Decline");
  } else {
    console.log(res.message);
  }
};
// get Product request
export const getUpdateProductRequest = (status) => async (dispatch) => {
  const res = await apiClient.get(
    `productRequest/updateProductRequestStatusWise?status=${status}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_UPDATE_PRODUCT_REQUEST,
      payload: res.data?.productRequests,
    });
  } else {
    console.log(res.message);
  }
};

export const updateProductAction = (productId, type) => async (dispatch) => {
  const res = await apiClient.patch(
    `productRequest/acceptUpdateRequest?requestId=${productId}&type=${type}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.PRODUCT_REQUEST_ACTION,
      payload: productId,
    });
    type === "Approved"
      ? setToast("success", "Product Request Accepted")
      : setToast("success", "Product Request Decline");
  } else {
    console.log(res.message);
  }
};
